module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sy-6ad1ad37127ed23355adc4999c23cb35.svg";